
import React from 'react';

const SolutionsSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
              Professional Safety Staffing Solutions
            </h2>
            
            <div className="prose prose-lg text-gray-700">
              <p className="mb-6">
                Fluctuating demands and project scales require sophisticated and adaptable safety staffing solutions. Construction has evolved to use a broad spectrum of safety professionals. Staff range from on-site safety coordinators for specific projects to long-term safety managers for large-scale operations.
              </p>
              
              <p className="mb-6">
                This diversity allows for tailored approaches to safety management. We match the right level of expertise to the particular needs of each project. With this flexibility, we can meet the challenges of each project with the appropriate level of skill and attention.
              </p>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <h3 className="text-xl font-semibold text-blue-800 mb-4">
                Key Benefits:
              </h3>
              <ul className="space-y-2 text-blue-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-500 mr-2 mt-1"></i>
                  Flexible staffing solutions
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-500 mr-2 mt-1"></i>
                  Project-specific expertise
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-500 mr-2 mt-1"></i>
                  Cost-effective resource allocation
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-500 mr-2 mt-1"></i>
                  Scalable safety management
                </li>
              </ul>
            </div>
          </div>
          
          <div>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Diversity of Staffing Options
              </h3>
              
              <p className="text-gray-700 mb-6">
                The diversity of staffing in safety management is vital in addressing varying needs. We offer a range of staffing solutions specific to your industry and need, from short-term placement related to particular phases of a project to long-term solutions overseeing the entire safety program of a project.
              </p>
              
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900">Short-term</h4>
                  <p className="text-sm text-gray-600">2-6 months</p>
                </div>
                
                <div className="text-center p-4 bg-gray-50 rounded-lg">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-2">
                    <i className="ri-calendar-line text-white text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900">Long-term</h4>
                  <p className="text-sm text-gray-600">6 months - 6 years</p>
                </div>
              </div>
              
              <button className="w-full bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Request Information
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
